<template>
  <div class="ac1">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <div class="w">
      <!-- banner -->
      <div class="banner">
        <img src="/imgs/banner.jpg" alt="" />
      </div>
      <!-- 动漫区块2 -->
      <div class="cm2">
        <!-- 动漫列表 爱发言的领导 -->
        <div class="cm2-list" id="1">
          <!-- 左侧 -->
          <div class="list-l">
            <h2>爱发言的领导</h2>
            <p>
              他是外表严肃的领导，内在是可爱呆萌的暖男
              他喜欢给员工开会，给员工加油鼓劲，是称职的领导
              尽管有的时候很严肃，但是当员工遇到困难时会挺身而出
            </p>
            <div class="l-btn">打包下载图片：2元</div>
          </div>
          <!-- 右侧 -->
          <div class="list-r">
            <!-- 循环项 -->
            <img :src="item.img" alt="" v-for="(item, index) in this.cm1" :key="index" />
          </div>
        </div>

        <!-- 动漫列表 开心胶囊 -->
        <div class="cm2-list" id="2">
          <!-- 左侧 -->
          <div class="list-l">
            <h2>开心胶囊</h2>
            <p>
              他是最可爱的小胶囊，他有圆圆的脑袋，圆圆的眼睛，红红的裤子
              他喜欢夏天，性格外向，表情丰富。 偶尔也会发小脾气，不过大家都非常的喜欢他
            </p>
            <div class="l-btn">打包下载图片：2元</div>
          </div>
          <!-- 右侧 -->
          <div class="list-r">
            <!-- 循环项 -->
            <img :src="item.img" alt="" v-for="(item, index) in this.cm2" :key="index" />
          </div>
        </div>

        <!-- 动漫列表 牟牟表情包 -->
        <div class="cm2-list" id="3">
          <!-- 左侧 -->
          <div class="list-l">
            <h2>牟牟表情包</h2>
            <p>
              它的名字叫牟牟,性格迷迷糊糊,又十分的胆小和顽皮
              它还是个好奇宝宝，总是有问不完的问题 表情丰富是大家的开心果
            </p>
            <div class="l-btn">打包下载图片：2元</div>
          </div>
          <!-- 右侧 -->
          <div class="list-r">
            <!-- 循环项 -->
            <img :src="item.img" alt="" v-for="(item, index) in this.cm3" :key="index" />
          </div>
        </div>
        
      </div>

      <!-- 分页 -->
      <div class="paging">
        <a href="/#/ac2">《</a>
        <a href="/#/ac2">1</a>
        <a href="/#/ac3">2</a>
        <a href="/#/ac3">》</a>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/NavHeader";
export default {
  name: "ac1",
  components: {
    NavHeader,
  },
  data() {
    return {
      href: "index.html",
      cm1: [],
      cm2: [],
      cm3: [],
      cm4: [],
      cm5: [],
      cm6: [],
      cm7: [],
      myData: [],
      mAc: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init1();
    document.title = "北京网文欣阅科技有限公司";
  },
  methods: {
    init1() {
      this.axios.get("/mock/a2.json").then((res) => {
        var data = res.data;
        this.cm1 = data.slice(0, 51);
        this.cm2 = data.slice(51, 101);
        this.cm3 = data.slice(101, 152);
      });

      this.axios.get("/mock/a3.json").then((res) => {
        var data = res.data;
        this.cm4 = data.slice(0, 51);
        this.cm5 = data.slice(51, 102);
        this.cm6 = data.slice(102, 152);
        this.cm7 = data.slice(152, 202);
      });
    },
    // 真实支付逻辑
    alipay(data) {
      console.log(data);
      var payAmount = 1.0; //支付价格
      var orderName = "动漫支付下载"; //订单名称
      var id = data.type; //订单名称

      // 已登录
      if (this.state == 0) {
        window.open(
          "http:///alipay/index.php?payAmount=" +
            payAmount +
            "&orderName=" +
            orderName +
            "&id=" +
            id
        );
      }
      // 未登录
      if (this.state !== 0) {
        alert("点击登录去购买~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
    // 跳转功能
    goDays(methodsWords, id) {
      this[methodsWords](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      // console.log('1')
      alert("资讯每篇1元，点击确定购买");
      this.showModal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac1 {
  background: #fafafa;
  .w {
    // banner 区块
    .banner {
      width: 100%;
      height: 500px;
      margin: 30px 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 动漫展示区块
    .cm1 {
      background: #fff;
      width: 100%;
      // height: 600px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin: 60px 0;
      padding: 20px;
      box-sizing: border-box;

      // 循环项
      .cm1-item {
        width: 245px;
        height: 370px;

        display: block;
        text-decoration: none;
        margin: 15px 0;

        img {
          width: 100%;
          height: 340px;
        }

        span {
          width: 100%;
          display: block;
          height: 30px;
          text-align: center;
          font-size: 14px;
          line-height: 30px;
          text-decoration: none;
        }
      }
    }

    // 动漫区块2
    .cm2 {
      width: 100%;
      background: #fff;
      .cm2-list {
        width: 100%;
        // height: 300px;
        display: flex;
        justify-content: space-between;
        border: 1px solid #ccc;
        margin: 20px 0;
        // 左侧
        .list-l {
          padding: 20px;
          box-sizing: border-box;
          width: 30%;
          height: 100%;
          // background-color: pink;
          p {
            width: 90%;
            font-size: 12px;
            line-height: 25px;
            margin-top: 15px;
            color: #2a2a2a;
          }
          h2 {
            font-size: 21px;
            font-weight: bold;
            color: #333;
          }

          .l-btn {
            width: 160px;
            height: 34px;
            text-align: center;
            line-height: 34px;
            color: #fff;
            background: #ff3955;
            cursor: pointer;
            border-radius: 20px;
            font-size: 14px;
            margin-top: 30px;
          }
        }
        // 右侧
        .list-r {
          width: 70%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          img {
            width: 136px;
            height: 145px;
            cursor: pointer;
          }
        }
      }
    }

    // 分页
    .paging {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 70px;
      a {
        display: inline-block;
        margin: 0 1px;
        background: #fff;
        cursor: pointer;
        text-decoration: none;
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px solid #d1d1d1;
        transition: all .2s;
        &:hover {
          background-color: $colorZ;
          color: #fff;
        }
      }
    }
  }
}
</style>
